export const getStatusCounts = state => state.statusCounts;
export const getNeedsRefresh = state => state.needsRefresh;
export const getNeedsGPRefresh = state => state.needsGPRefresh;
export const getNeedsUnmatchedServiceCountRefresh = state =>
  state.needsUnmatchedServiceCountRefresh;
export const getRobotCounts = state => state.robotCounts;
